<!-- Loading state -->
<div class="loading-state" *ngIf="!resultReady">
  <qai-loading size="medium" />
  <span class="loading-label">{{
    "results.PROCESSING_RESULTS" | transloco
  }}</span>
</div>

<ng-container *ngIf="resultReady && translationLoaded">
  <!-- Hero -->
  <div class="hero">
    <div class="hero-text">
      <h2 class="hero-title">
        {{ "results.QUIZ_RESULTS_SUMMARY" | transloco }}
      </h2>
      <p class="hero-subtitle">
        {{
          embeddedQuizSummaryTranslationKey
            | transloco
              : {
                  stepNames: embeddedQuizReviewStepNamesText,
                  stepWord: embeddedQuizStepWord,
                  stepVerb: embeddedQuizStepVerb,
                  areaWord: embeddedQuizAreaWord,
                }
        }}
      </p>
    </div>

    <div class="hero-score">
      <!-- Out of compliance replaces the score -->
      @if (isUserCompliant === false) {
        <div class="score-badge warning">
          <div class="score-value">{{ "results.OUT_OF_COMPLIANCE" | transloco }}</div>
        </div>
      } @else {
        <div
          class="score-badge"
          [ngClass]="{
            success: hasPassed,
          }"
        >
          <div class="score-value">
            {{
              callScoreCalcType === calcTypeRatio5pt0min
                ? (practiceScore | number: "1.1-2")
                : callScoreCalcType === "RATIO_100PT_0MIN"
                  ? localeService.formatPercentage(practiceScore, localeService.getDecimalPlaces(practiceScore, 2))
                  : (practiceScore | number: "1.0-2")
            }}
          </div>
          <div class="score-label">
            {{ totalPositivePoints }}/{{ totalPoints }}
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Out of compliance: guidelines the learner missed -->
  @if (isUserCompliant === false) {
    <div class="feedback">
      <div class="content">
        <div class="questions">
          <app-compliance-missed-guidelines class="question-result" [complianceScoringResult]="complianceScoringResult" [complianceOnly]="complianceOnly" />
        </div>
      </div>
    </div>
  }

  <!-- Feedback Content -->
  @if (showFeedback) {
    <div class="feedback">
      <div class="content">
        <div class="questions">
          <div
            class="question-result"
            *ngFor="let question of guidedResults?.questions"
          >
            <div class="question">
              {{ question.name }}
              <div class="total-points">
                {{ question.practiceCallGuided.totalPositivePoints }} /
                {{ question.practiceCallGuided.totalPoints }}
              </div>
            </div>

            <div class="talking-points">
              <!-- Covered: always occupies its space; content hidden when no covered points -->
              <div class="talking-point">
                @if (question.practiceCallGuided.positiveContext.length > 0) {
                  <div class="talking-point-title covered">
                    {{ "results.COVERED" | transloco }}
                  </div>
                  <div class="points">
                    <div class="points-list">
                      @for (point of question.practiceCallGuided.positiveContext; track point) {
                        <div class="point">
                          <qai-glyph kind="check-brand" [spotlight]="'brand'" [size]="'22px'"></qai-glyph>
                          {{ point }}
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>

              <!-- Missed: always occupies its space; content hidden when no missed points -->
              <div class="talking-point">
                @if (question.practiceCallGuided.negativeContext.length > 0) {
                  <div class="talking-point-title missed">
                    {{ "results.MISSED" | transloco }}
                  </div>
                  <div class="points">
                    @if (!showMissedFacts) {
                      <div class="missed-summary">
                        @if (question.practiceCallGuided.negativeContext.length === 1) {
                          {{ "results.MISSED_ONE_TALKING_POINT" | transloco }}
                        } @else {
                          {{ "results.MISSED_X_TALKING_POINTS" | transloco: { count: question.practiceCallGuided.negativeContext.length } }}
                        }
                      </div>
                    } @else {
                      <div class="points-list">
                        @for (point of question.practiceCallGuided.negativeContext; track point) {
                          <div class="point">
                            <qai-glyph kind="x-close-error" [spotlight]="'error'" [size]="'22px'"></qai-glyph>
                            <div>{{ point }}</div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</ng-container>
